import React from "react";
import {Notice} from "@/model/alarm/Notice";
import {Label} from "@/components/ui/label";
import {formatIsoReadable} from "@/utils/dateUtils";


const NoticeHistory: React.FC<{notice: Notice}> = ({notice}) => {
    return (
        <div className="flex flex-col gap-3 px-5 py-3 border border-gray-300 rounded-lg">
            <div className="flex flex-col gap-2">
                <Label>발송 일자</Label>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                    {formatIsoReadable(notice.createdAt)}
                </p>
            </div>
            <div className="flex flex-col gap-2">
                <Label>공지 내용</Label>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                    {notice.content.notice}
                </p>
            </div>
        </div>
    )
}

export default NoticeHistory;